import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import InformationRegisterSMAList from './InformationRegisterSMAList';

const InformationRegisterSMA = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: 'Medio Ambiente' },
		{ to: '#', label: 'Parámetros Ambientales' } 
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Catastro' links={breadcrumbLinks} />
					<InformationRegisterSMAList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default InformationRegisterSMA;
